module.exports = __webpack_public_path__ + "assets/img/hzhb4.2182a1ec.png";